import { t } from "@lingui/macro";
import { IApiEntitySmpAgSticker } from "@smp/api";
import { REACT_APP__BASE_PATH } from "@smp/utils";
import { useMemo } from "react";

import { getLocationOrigin } from "@/utils";

export type IStickerMeta = {
  name: string;
  title: string;
  desc: string;
  author: string | undefined;
  image: string;
  keywords: string | undefined;
  canonical: string;
};

export const useStickerMeta = (
  sticker: IApiEntitySmpAgSticker | undefined,
): IStickerMeta | undefined => {
  const stickerName = sticker?.name?.trim() || t`Sticker` + " " + sticker?.id;

  const origin = useMemo(getLocationOrigin, []);

  return useMemo(
    () =>
      sticker
        ? {
            name: stickerName,
            title: [
              stickerName,
              t`stickers for social networks, messengers and advertising creatives`,
              t`Canvas` + " SMMplanner",
            ].join(" - "),
            desc: (() => {
              const desc = sticker.description;

              if (!desc) {
                return t`Sticker on the theme «${stickerName}», which can be easily edited to your requirements in the graphical online editor of the canvas from the SMMPlanner service.`;
              }

              return desc.split("\n")[0];
            })(),
            author: sticker.tags
              ?.find((tag) => tag.startsWith("author_"))
              ?.replace(/^author_/, ""),
            image: sticker.image_original_url || sticker.image_preview_url,
            keywords: sticker.keywords || undefined,
            canonical: `${origin}${REACT_APP__BASE_PATH}/stickers/${sticker.id}`,
          }
        : undefined,
    [origin, sticker, stickerName],
  );
};
